// extracted by mini-css-extract-plugin
export default {"container":"k2XDk3_vQWBlAwYohzpe","item":"OSD0wE5HmyTsh7WDyw0Z"};